import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { ServicesSection } from '../components/ServicesSection';
import { PackagesSection } from '../components/PackagesSection';
import { DeerPackagesSection } from '../components/DeerPackagesSection';
import { TurkeyPackageSection } from '../components/TurkeyPackageSection';
import { PremiumPackageSection } from '../components/PremiumPackageSection';
import { FishingSection } from '../components/FishingSection';
import { RulesAndSpecialsSection } from '../components/RulesAndSpecialsSection';
import { GallerySection } from '../components/GallerySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { FloatingCallButton } from '../components/FloatingCallButton';
import { translations } from '../mock';
import { Toaster } from '../components/ui/sonner';

const applyPrices = (base, prices) => {
  if (!prices) return base;
  const t = JSON.parse(JSON.stringify(base));
  const setP = (item, key) => { if (item && prices[key]) item.price = prices[key]; };
  if (t.packages?.items) {
    setP(t.packages.items[0], 'bear_camping');
    setP(t.packages.items[1], 'bear_chalet');
    setP(t.packages.items[2], 'bear_vip');
  }
  if (t.deerPackages?.items) {
    setP(t.deerPackages.items[0], 'deer_camping');
    setP(t.deerPackages.items[1], 'deer_chalet');
    setP(t.deerPackages.items[2], 'deer_vip');
  }
  setP(t.turkeyPackage?.package, 'turkey');
  setP(t.premiumPackage?.package, 'premium');
  return t;
};

export const Home = () => {
  const [language, setLanguage] = useState('fr');
  const [prices, setPrices] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/prices`)
      .then(res => setPrices(res.data))
      .catch(() => {});
  }, []);

  const t = useMemo(() => applyPrices(translations[language], prices), [language, prices]);

  return (
    <div className="min-h-screen bg-black">
      <Header language={language} setLanguage={setLanguage} t={t} />
      <HeroSection t={t} />
      <AboutSection t={t} />
      <ServicesSection t={t} />
      <PackagesSection t={t} />
      <DeerPackagesSection t={t} />
      <TurkeyPackageSection t={t} />
      <PremiumPackageSection t={t} />
      <FishingSection t={t} />
      <RulesAndSpecialsSection t={t} />
      <GallerySection t={t} />
      <TestimonialsSection t={t} />
      <ContactSection t={t} />
      <Footer t={t} />
      <FloatingCallButton language={language} />
      <Toaster position="top-right" />
    </div>
  );
};
